export interface PostYieldAnalsisParameters {
  tubularStringId?: string;
  hollidayStressRatio: number | null;
}

export class PostYield {
  public constructor(init?: Partial<PostYield> & { postYieldAnalysisParameters?: PostYieldAnalsisParameters | PostYieldAnalsisParameters[] }) {
    Object.assign(this, init);

    const analysisParameters = Array.isArray(init?.postYieldAnalysisParameters)
      ? init.postYieldAnalysisParameters[0]
      : init?.postYieldAnalysisParameters;

    this.designId = init?.designId || '';
    this.tubularStringId = init?.tubularStringId || '';
    this.postYieldAnalsisParameters = {
      hollidayStressRatio:
        init?.postYieldAnalsisParameters?.hollidayStressRatio ??
        analysisParameters?.hollidayStressRatio ??
        null
    };
  }

  public designId: string;
  public tubularStringId: string;
  public postYieldAnalsisParameters: PostYieldAnalsisParameters;
  public postYieldAnalysisParameters?: PostYieldAnalsisParameters[];
}